import { render, staticRenderFns } from "./previewSobreDrag.vue?vue&type=template&id=b80bb412"
import script from "./previewSobreDrag.vue?vue&type=script&lang=js"
export * from "./previewSobreDrag.vue?vue&type=script&lang=js"
import style0 from "./previewSobreDrag.vue?vue&type=style&index=0&id=b80bb412&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports